import LocalStorageService from '../../LocalStorage/LocalStorage.service';
import Dates from '../../../utils/dates';

const CommunicationService = {
  getVariable: (key) => LocalStorageService.get(key),
  saveVariable: (key, value) => {
    if (key === 'prestation-code') {
      CommunicationService.setDateLastResponse(key);
    }
    LocalStorageService.set(key, value);
  },
  checkPathnameConfig: (currentPath, paths) =>
    paths?.some((path) => currentPath.includes(path)) || !paths,
  showByDate: (initDate, expireDate) =>
    CommunicationService.checkInitialDateConfig(initDate) &&
    CommunicationService.checkExpirationDateConfig(expireDate),
  checkPrestationCode: (key, initDate, expireDate) =>
    CommunicationService.showByDate(initDate, expireDate) &&
    CommunicationService.showByDateLastResponse(key),
  checkCircleConfig: (acceptCircle, isCircle) =>
    (!acceptCircle && typeof isCircle !== 'undefined' && !isCircle) || acceptCircle,
  checkExpirationDateConfig: (expire) =>
    (expire && Dates.get(expire, 'DD-MM-yyyy').compareIsAfter(new Date())) || !expire,
  checkInitialDateConfig: (initDate) =>
    (initDate && Dates.get(initDate, 'DD-MM-yyyy').compareIsBefore(new Date())) || !initDate,
  setDateLastResponse: (variable) =>
    CommunicationService.saveVariable(`${variable}-lastResponse`, new Date()),
  getDateLastResponse: (variable) => CommunicationService.getVariable(`${variable}-lastResponse`),
  showByDateLastResponse: (variable) => {
    const dateLastResponse = CommunicationService.getDateLastResponse(variable);
    return (
      (dateLastResponse &&
        Dates.getWithAddDays(30, dateLastResponse).compareIsBefore(new Date())) ||
      !dateLastResponse
    );
  },
  validationByKey: (key, initDate, expire) =>
    key === 'prestation-code'
      ? CommunicationService.checkPrestationCode(key, initDate, expire)
      : !LocalStorageService.get(key) && CommunicationService.checkExpirationDateConfig(expire),
  /**
   *
   * @param {String} variable
   * @param {String} initDate
   * @param {String} expire
   * @param {boolean} acceptCircle
   * @param {boolean} isCircle
   * @param {String} pathname
   * @param {String} paths
   * @returns boolean
   */
  checkShowCommunication: (variable, initDate, expire, acceptCircle, isCircle, pathname, paths) => {
    return (
      CommunicationService.checkPathnameConfig(pathname, paths) &&
      CommunicationService.checkCircleConfig(acceptCircle, isCircle) &&
      CommunicationService.validationByKey(variable, initDate, expire)
    );
  },
  isPractitionerAMBA: (managmentUnitResponse) => {
    let managmentUnitOutcome = 'A';
    let unidadesDeGestion = [];

    if (managmentUnitResponse && managmentUnitResponse.length > 0) {
      managmentUnitOutcome = 'A';
      managmentUnitResponse.forEach((unidades) => unidadesDeGestion.push(unidades.unidadGestion));
      // para simular:
      // unidadesDeGestion = [ 6 ]
      // Solo 6
      if (unidadesDeGestion.length === 1 && unidadesDeGestion.includes(6))
        managmentUnitOutcome = 'I';
      // Si vienen varias unidades de gestión, es interior cuando trae 6 y cualquier otra distinta de 5.
      if (
        unidadesDeGestion.length > 1 &&
        unidadesDeGestion.includes(6) &&
        !unidadesDeGestion.includes(5)
      )
        managmentUnitOutcome = 'I';
    }

    return managmentUnitOutcome === 'A';
  },
};

export default CommunicationService;
